<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates36">
<p class="centerImage"><img alt="images" id="plate36" src="images/plate36.jpg"/></p>
<p class="caption">Robin Norwood and me impressing the press, again!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates36.vue?306438b2